import * as React from 'react'
import {
	Box,
	Typography,
	type BoxProps,
	type TypographyProps,
} from '@mui/material'
import { InfoOutlineRounded } from '@mui/icons-material'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/material/styles'

export const CardContainer: React.FC<BoxProps> = styled( Box )<BoxProps >( ( { theme } ) => ( {
	alignItems: 'center',
	border: `2px solid ${grey[ 400 ]}`,
	borderRadius: theme.shape.borderRadius,
	display: 'flex',
	flexDirection: 'row',
	gap: theme.spacing( 3 ),
	padding: theme.spacing( 2 ),
	width: 'max-content',
	[ theme.breakpoints.down( 1000 ) ]: {
		alignItems: 'flex-start',
		flexDirection: 'column',
		maxWidth: `calc(600px - ${theme.spacing( 4 )})`,
		width: 'inherit',
		gap: theme.spacing( 1.5 ),
		flex: 0.2,
	},
} ) )

export const ChipContainer: React.FC<BoxProps> = styled( Box )<BoxProps >( () => ( {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
} ) )

export const UpdateContainer: React.FC<BoxProps> = styled( Box )<BoxProps >( () => ( {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
} ) )

export const UpdateTypography: React.FC<TypographyProps> = styled( Typography )<TypographyProps >( ( { theme } ) => ( {
	alignItems: 'center',
	display: 'flex',
	fontSize: theme.typography.body2.fontSize,
	lineHeight: theme.spacing( 3 ),
} ) )

export const DetailsContainer: React.FC<BoxProps> = styled( Box )<BoxProps >( ( { theme } ) => ( {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	maxWidth: theme.spacing( 50 ),
} ) )

export const DetailsTypography: React.FC<TypographyProps> = styled( Typography )<TypographyProps >( ( { theme } ) => ( {
	fontSize: theme.typography.body2.fontSize,
	lineHeight: theme.spacing( 2.5 ),
} ) )

export const TooltipIcon: React.FC = styled( InfoOutlineRounded )( ( { theme } ) => ( {
	color: grey[ 500 ],
	height: 20,
	marginLeft: theme.spacing( 0.5 ),
	width: 20,
} ) )

export const ContactSupportTypography: React.FC<TypographyProps> = styled( Typography )<TypographyProps >( ( { theme } ) => ( {
	fontSize: theme.typography.body2.fontSize,
	lineHeight: theme.spacing( 2.5 ),
	color: theme.palette.primary.main,
	cursor: 'pointer',
} ) )
